import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../dashboard.selectors';
import * as fromTemplates from './templates.reducer';

export const selectTemplateState = createSelector(selectDashboardState, (dashboard) => dashboard?.template);

export const selectIsLoadingTemplates = createSelector(
  selectTemplateState,
  (templateState) => templateState?.loadingTemplates
);

export const selectTemplatesLoaded = createSelector(
  selectTemplateState,
  (templateState) => templateState?.templatesLoaded
);

export const selectTemplates = createSelector(selectTemplateState, fromTemplates.selectAll);

export const selectSelectedTemplate = createSelector(
  selectTemplateState,
  (templateState) => templateState?.selectedTemplate
);

export const selectIsLoadingTemplate = createSelector(
  selectTemplateState,
  (templateState) => templateState?.loadingTemplate
);

export const selectTemplateLoaded = createSelector(
  selectTemplateState,
  (templateState) => templateState?.templateLoaded
);

export const selectSupportedLanguages = createSelector(
  selectTemplateState,
  (templateState) => templateState.supportedLanguages
);

export const selectSelectedLanguage = createSelector(
  selectTemplateState,
  (templateState) => templateState.selectedLanguage
);

export const selectIsImportingTemplate = createSelector(
  selectTemplateState,
  (templateState) => templateState.importingTemplate
);

export const selectTemplateImported = createSelector(
  selectTemplateState,
  (templateState) => templateState.templateImported
);
